import { Pipe, PipeTransform } from '@angular/core';
import { formatToUtcZ } from '@shared/utils/helper';

@Pipe({ name: 'formatUtcZ' })
export class FormatUtcZPipe implements PipeTransform {
    transform(value: string): string {
        return formatToUtcZ(value);
    }
}
